import React, { useContext } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Link } from "react-router-dom";
import Fade from "@material-ui/core/Fade";
import Nav from "./Nav";
import { UserContext } from "./UserContext";

const useStyles = makeStyles((theme) => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  card: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  cardMedia: {
    paddingTop: "56.25%", // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
}));

export default function Album() {
  const classes = useStyles();

  const { user } = useContext(UserContext);

  return (
    <React.Fragment>
      <Nav />
      <CssBaseline />
      <main>
        {/* Hero unit */}
        <div className={classes.heroContent}>
          <Fade in={true} timeout={3500}>
            <Container maxWidth="sm">
              <Typography
                component="h1"
                variant="h2"
                align="center"
                color="textPrimary"
                gutterBottom
              >
                Administration Control Panel
              </Typography>
              <div className={classes.heroButtons}>
                <Grid container spacing={2} justify="center">
                  {user.role === "admin" && (
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        component={Link}
                        to="/users"
                      >
                        MANAGE SYSTEM USERS
                      </Button>
                    </Grid>
                  )}
                    {user.role === "admin" && (
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        component={Link}
                        to="/tracking"
                      >
                        MANAGE WHITELIST STATUS
                      </Button>
                    </Grid>
                  )}
                  {user.role === "staff" && (
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        component={Link}
                        to="/tracking"
                      >
                        MANAGE PLAYERS WHITELIST STATUS
                      </Button>
                    </Grid>
                  )}
                    {user.role === "admin" && (
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        component={Link}
                        to="/factions"
                      >
                        MANAGE PLAYERS FACTION
                      </Button>
                    </Grid>
                  )}
                  {user.role === "staff" && (
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        component={Link}
                        to="/factions"
                      >
                        MANAGE PLAYERS FACTION
                      </Button>
                    </Grid>
                  )}
                </Grid>
              </div>
            </Container>
          </Fade>
        </div>
      </main>
    </React.Fragment>
  );
}
